module.exports = "/_next/static/images/mandiri-icon-a696d5eefc59d2600bcfac41322640ff.svg";